import { render, staticRenderFns } from "./BusinessNameDataUpdateFormDetails.vue?vue&type=template&id=1f382414&scoped=true&"
import script from "./BusinessNameDataUpdateFormDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateFormDetails.vue?vue&type=style&index=0&id=1f382414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f382414",
  null
  
)

export default component.exports